import { createFileRoute, redirect } from "@tanstack/react-router";

/** Growth opens on the promo codes. */
export const Route = createFileRoute("/_app/growth/")({
  beforeLoad: () => {
    throw redirect({ to: "/growth/promo-codes", replace: true });
  },
});
